
// SVG Icon: external-link
export default { id: "terriajs-external-link" };
export const id = "terriajs-external-link";
export const name = "external-link";
